import { Button, Tooltip } from '@mui/material';
import { MdAdd } from '@teamworksdev/icons';
import { DateTime } from 'luxon';
import { DisabledWithTooltip } from '../../../../components/permissions/DisabledWithTooltip';
import { TimelineItem } from '../types';
import { TRACK_HEIGHT } from '../utils';

interface HoverButtonProps extends TimelineItem {
  offset: number;
  onClick: (date: DateTime) => void;
  onRightClick?: (date: DateTime) => void;
  ariaLabel: string;
  /** When set, the button is disabled and this explains why on hover. */
  disabledReason?: string;
}

export const HoverButton = ({
  timelineStart,
  dateHeaderScale,
  offset,
  onClick,
  onRightClick,
  ariaLabel,
  disabledReason,
}: HoverButtonProps) => {
  const hoverDate = timelineStart.plus({ days: offset / dateHeaderScale });

  return (
    <Tooltip
      disableInteractive
      placement="top"
      title={hoverDate.toFormat('EEE, MMM d, y')}
      arrow
    >
      <div
        className="absolute flex items-center justify-center -translate-x-1/2 z-20"
        style={{
          height: TRACK_HEIGHT,
          left: offset,
        }}
      >
        <DisabledWithTooltip
          disabled={disabledReason !== undefined}
          reason={disabledReason ?? ''}
        >
          <Button
            variant="outlined"
            className="p-1 min-w-0"
            aria-label={ariaLabel}
            onClick={() => onClick(hoverDate)}
            onContextMenu={() => onRightClick?.(hoverDate)}
          >
            <MdAdd aria-hidden="true" size={24} />
          </Button>
        </DisabledWithTooltip>
      </div>
    </Tooltip>
  );
};
